/**
 * Iter-104 — Cross-platform country flag.
 *
 * Background: regional-indicator flag emoji are not rendered as flags on Chrome
 * for Windows (Microsoft does not ship the color-emoji flag glyphs). We display
 * a tiny SVG from flagcdn.com (free, no API key) so every browser sees a flag.
 *
 * Usage:
 *   <Flag code="MA" />                  // 16 px wide flag
 *   <Flag code="MA" size={24} />        // larger
 *   <Flag code="MA" alt={false} />      // hide alt for purely decorative usage
 *
 * Falls back to nothing when `code` is missing/invalid (we never want a broken
 * placeholder leaking into UI screenshots).
 */
import React from "react";

export default function Flag({ code, size = 16, alt = true, className = "" }) {
  if (!code || typeof code !== "string" || code.length !== 2) return null;
  const lc = code.toLowerCase();
  // Pick the smallest sane resolution for a 16-24 px target.
  const w = size <= 16 ? 20 : size <= 24 ? 32 : 48;
  return (
    <img
      src={`https://flagcdn.com/${w}x${Math.round(w * 0.75)}/${lc}.png`}
      srcSet={`https://flagcdn.com/${w * 2}x${Math.round(w * 1.5)}/${lc}.png 2x`}
      alt={alt ? code.toUpperCase() : ""}
      width={size}
      height={Math.round(size * 0.75)}
      style={{ display: "inline-block", verticalAlign: "middle", borderRadius: 2, boxShadow: "0 0 0 1px rgba(0,0,0,0.06)" }}
      loading="lazy"
      decoding="async"
      className={className}
    />
  );
}
